import React from "react"
import { Row, Col } from "reactstrap";
import banner from "../../assets/images/banner/banner.jpg";
import { useHistory } from "react-router-dom";
import logoutImg from "jsbimages/logout_icon.png"

const Header = () => {
    const history = useHistory();

    return (
        <React.Fragment>
            <Row>
                <Col className="navbar-header" lg="12">
                    <div style={{ width: "102%", backgroundColor: "#9a084f", height: "70px", marginLeft: "-20px", overflow: "hidden", top: "0px", position: "relative" }}>
                        <Row>
                            <Col lg="5" sm="2">
                                <img className="img-fluid.max-width: 100%;height:auto" style={{ height: "70px", marginLeft: "20px" }} src={banner} alt="Banner" />
                            </Col>
                            <Col lg="4" sm="2">
                                <label style={{ fontSize: "25px", color: "white", marginTop: "15px" }}>Online Account Application</label>
                            </Col>
                            <Col lg="3" sm="2" style={{ textAlign: "right" }}>
                                <button type="button" className="btn" style={{ color: "white", fontSize: "large", marginTop: "10px" }}
                                    onClick={() => {
                                        localStorage.clear();
                                        history.push('/login');
                                    }} >
                                    <span className="bx bx-log-in" style={{ fontSize: "x-large", marginTop: "5px", paddingRight: "5px" }}></span>
                                    <label style={{ marginTop: "10px", fontSize: "larger" }}> Logout </label>
                                </button>
                            </Col>
                        </Row>
                    </div>
                </Col>
            </Row>
        </React.Fragment >
    );
};

export default Header


